import React, { useState, useEffect, useRef } from "react";
import { UTILS } from "../../constants";
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import axios from "axios";
export const CartTitle = ({ cardDetail,handlecardtitle,handleUntrash }) => {
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);
  const [title, setTitle] = useState("");  
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [getattachemtID, setgetattachemtID] = useState(null);
  const handleShows = (id) => {
    setShow(true);
    setgetattachemtID(id);
  };
  useEffect(() => {
    setTitle(cardDetail.title);
  }, [cardDetail.title]);

  const updateCardTitle = async () => {
    try {
      const randomString = Math.random().toString(36).substring(2, 5);
      const mainurl = `${UTILS.API_url}board/v1/board-list-cards/title/update?${randomString}`;
      const data = new FormData();
      data.append("title", title);
      data.append("task_id", cardDetail.id);
      const response = await axios.post(mainurl, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("trelloToken")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      handlecardtitle(cardDetail.id,title);

      // console.log("response", response);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  return (
    <div className="front-title">
      {isEditing ? (
        <input
          type="text"
          ref={inputRef}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onBlur={() => {
            setIsEditing(false);
            updateCardTitle();
          }}
        />
      ) : (
        console.log("deleted card",cardDetail),
          <>
            <p
              className="editableText"
              style={{ justifyContent: "flex-start" }}
              onClick={() => {if (!cardDetail?.deleted_at) {
                setIsEditing(true);
              }}}
            >
            {title}
            </p>
            {(cardDetail?.deleted_at)?
            <span className="material-symbols-outlined"
            style={{cursor:"pointer"}} 
            onClick={() => {if (cardDetail?.deleted_at) {
              handleShows(cardDetail?.id);
              }}}>restore_from_trash</span>:''}
          </>
          
      )}

<Modal className="deleteModal" show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="modalHead">
            <span class="material-symbols-outlined">warning</span>
            {/* <h4>Are You Sure ?</h4> */}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>Are you sure you want to Restore this Card.</Modal.Title>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleUntrash(getattachemtID);
              handleClose();
            }}
            style={{ backgroundColor: 'red', color: 'white', border: 'none' }}
          >
            Restore
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
